import { render, staticRenderFns } from "./NodeTest.vue?vue&type=template&id=6bb5d0e4&scoped=true"
import script from "./NodeTest.vue?vue&type=script&lang=js"
export * from "./NodeTest.vue?vue&type=script&lang=js"
import style0 from "./NodeTest.vue?vue&type=style&index=0&id=6bb5d0e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb5d0e4",
  null
  
)

export default component.exports